// extracted by mini-css-extract-plugin
module.exports = {"section":"M_bh","commonQuestionsTitle":"M_dp","sectionTitle":"M_dq","separator":"M_dr"};